import SmallBlueTick from '@propertypal/shared/src/resources/icons/checklist/small-blue-tick.svg';
import SmallGreenTick from '@propertypal/shared/src/resources/icons/checklist/small-green-tick.svg';
import SmallOrangeTick from '@propertypal/shared/src/resources/icons/checklist/small-orange-tick.svg';
import SmallPurpleTick from '@propertypal/shared/src/resources/icons/checklist/small-purple-tick.svg';
import React from 'react';
import BenefitsChecklist from '../../checklists/benefits-checklist/BenefitsChecklist';
import BenefitsChecklistElement from '../../checklists/benefits-checklist-element/BenefitsChecklistElement';
import MortgageBenefitsWrapper from './MortgageBenefits.style';

interface MortgageBenefitsProps {
  maxWidth?: number;
  padding?: string;
  border?: number;
  bgColor?: string;
  zIndex?: string;
  fontColor?: string;
  allOrangeTicks?: boolean;
  breakPoint?: string;
}

const MortgageBenefits = (props: MortgageBenefitsProps) => {
  return (
    <MortgageBenefitsWrapper zIndex={props.zIndex} background={props.bgColor}>
      <BenefitsChecklist
        fontColor={props.fontColor}
        maxWidth={props.maxWidth}
        borderBottomRightRadius={props.border ? props.border : 8}
        borderBottomLeftRadius={props.border ? props.border : 8}
        padding={props.padding}
      >
        <BenefitsChecklistElement
          breakPoint={props.breakPoint}
          icon={props.allOrangeTicks ? SmallOrangeTick : SmallOrangeTick}
          text="No Fees"
          bolded="No Fees"
        />
        <BenefitsChecklistElement
          breakPoint={props.breakPoint}
          text="Free impartial advice"
          icon={props.allOrangeTicks ? SmallOrangeTick : SmallBlueTick}
          bolded="Free"
        />
        <BenefitsChecklistElement
          breakPoint={props.breakPoint}
          icon={props.allOrangeTicks ? SmallOrangeTick : SmallGreenTick}
          text="Real time mortgage rates"
          bolded="Real time"
        />
        <BenefitsChecklistElement
          breakPoint={props.breakPoint}
          icon={props.allOrangeTicks ? SmallOrangeTick : SmallPurpleTick}
          text="Online and Face to Face meetings"
          bolded="Online|Face to Face"
        />
      </BenefitsChecklist>
    </MortgageBenefitsWrapper>
  );
};

export default MortgageBenefits;
